import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { putZoneFailed, putZoneSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { makeParkingLotPatchPayload } from './mapParkingLotsToZones';

const REGULAR_CLASS_ID = 1;
const BENEFIT_CLASS_ID = 2;

export default function* putZoneById(action) {
  try {
    const {
      id,
      date,
    } = action.payload;

    const baseUrl = `${BACKEND_URL}/proxy/parking-registration/v1/parking_lots`;

    const regularPayload = makeParkingLotPatchPayload(
      id,
      date?.regular_spaces,
      date?.regular_busy_spaces,
    );

    const benefitPayload = makeParkingLotPatchPayload(
      id,
      date?.benefit_spaces,
      date?.benefit_busy_spaces,
    );

    const regularResponse = yield makeRequest(`${baseUrl}?class_id=${REGULAR_CLASS_ID}`, regularPayload, action, 'PATCH', true);
    const regularData = yield regularResponse.json();

    if (regularResponse.status !== OK) {
      yield put(putZoneFailed([]));
      yield call(rejectActionPromise(action, regularData));

      return;
    }

    const benefitResponse = yield makeRequest(`${baseUrl}?class_id=${BENEFIT_CLASS_ID}`, benefitPayload, action, 'PATCH', true);
    const benefitData = yield benefitResponse.json();

    if (benefitResponse.status === OK) {
      yield put(putZoneSuccessful([]));
      yield call(resolveActionPromise(action, benefitData));
    } else {
      yield put(putZoneFailed([]));
      yield call(rejectActionPromise(action, benefitData));
    }
  } catch (e) {
    yield put(putZoneFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
